import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import "./styles/styles.sass";

// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";

// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyDpMpFuK2O_B0BW7zC7AQ8sVOOzC6LQbLs",
  authDomain: "fennex-ec.firebaseapp.com",
  projectId: "fennex-ec",
  storageBucket: "fennex-ec.appspot.com",
  messagingSenderId: "132932748897",
  appId: "1:132932748897:web:4d7054e3981d230ff58c20",
  measurementId: "G-WPR6SCDGVK"
};

// Initialize Firebase
initializeApp(firebaseConfig);
getAnalytics();

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <ToastContainer/>
    <App />
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();